import { c as _c } from "react/compiler-runtime";
import { Switch } from "@headlessui/react";
import { classNames } from "@/helpers/Helpers";
export default function ProxyCreateActionConfigEndTimeSwitch(t0) {
  const $ = _c(27);
  const {
    isActive,
    setIsActive
  } = t0;
  const t1 = isActive ? "tw-bg-primary-500" : "tw-bg-iron-700";
  let t2;
  if ($[0] !== t1) {
    t2 = classNames(t1, "tw-p-0 tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-flex-shrink-0 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-duration-200 tw-ease-in-out");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-sr-only">No end time</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isActive ? "tw-translate-x-5" : "tw-translate-x-0";
  let t5;
  if ($[3] !== t4) {
    t5 = classNames(t4, "tw-pointer-events-none tw-relative tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out");
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isActive ? "tw-opacity-0 tw-duration-100 tw-ease-out" : "tw-opacity-100 tw-duration-200 tw-ease-in";
  let t7;
  if ($[5] !== t6) {
    t7 = classNames(t6, "tw-absolute tw-inset-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-transition-opacity");
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-h-3 tw-w-3 tw-text-iron-400" fill="none" aria-hidden="true" viewBox="0 0 12 12"><path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <span className={t7} aria-hidden="true">{t8}</span>;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = isActive ? "tw-opacity-100 tw-duration-200 tw-ease-in" : "tw-opacity-0 tw-duration-100 tw-ease-out";
  let t11;
  if ($[10] !== t10) {
    t11 = classNames(t10, "tw-absolute tw-inset-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-transition-opacity");
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <svg className="tw-h-3 tw-w-3 tw-text-primary-500" fill="currentColor" viewBox="0 0 12 12"><path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" /></svg>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11) {
    t13 = <span className={t11} aria-hidden="true">{t12}</span>;
    $[13] = t11;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13 || $[16] !== t5 || $[17] !== t9) {
    t14 = <span className={t5}>{t9}{t13}</span>;
    $[15] = t13;
    $[16] = t5;
    $[17] = t9;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== isActive || $[20] !== setIsActive || $[21] !== t14 || $[22] !== t2) {
    t15 = <Switch checked={isActive} onChange={setIsActive} className={t2}>{t3}{t14}</Switch>;
    $[19] = isActive;
    $[20] = setIsActive;
    $[21] = t14;
    $[22] = t2;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="tw-ml-3 tw-whitespace-nowrap tw-text-iron-300 tw-text-sm tw-font-medium">No end time</span>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15) {
    t17 = <div className="tw-mt-4 tw-flex tw-items-center">{t15}{t16}</div>;
    $[25] = t15;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
}